export default __webpack_public_path__ + "static/media/Tanu.23fbb20b.jpeg";